import type { CoviThreadMeta } from "../model/types"

/**
 * Whether the thread on screen is a conversation the user is actually in.
 *
 * This is the line between "Sofia may take this surface over" and "leave it
 * alone". A page publishing a summary, or the Sofia tab arriving on Home, is
 * welcome to use a thread nobody has said anything in; taking one the user is
 * mid-conversation in reads as their chat being replaced.
 *
 * A thread a PAGE opened is still on trial until the user answers it, so it
 * never counts however much seeded prose it carries — otherwise the first
 * summary of a browsing session would block every summary after it. Sending a
 * message promotes the trial, and from that moment the thread is theirs.
 *
 * Message count is the whole signal: a turn in flight always follows the user
 * message that started it, so streaming is engagement by the time it begins. An
 * unsent composer draft is NOT covered — drafts live in `CoviPanel` component
 * state and never reach the registry.
 */
export function isThreadEngaged(
  threads: readonly CoviThreadMeta[],
  activeThreadId: string | null,
  trialThreadId: string | null,
): boolean {
  if (!activeThreadId || activeThreadId === trialThreadId) {
    return false
  }
  const active = threads.find((thread) => thread.id === activeThreadId)
  return (active?.messageCount ?? 0) > 0
}
